module.exports = {
  INVALID_USER_INPUT: 4000,
  UNCORRECT_FORGOT_CODE: 4001,
  CAPTCHA_TOKEN_REQUIRED: 4002,

  UNAUTHORIZED: 4100,
  AUTH_ERROR: 4101,
  LOGIN_NOT_EXIST: 4102,
  ACCOUNT_SUSPENDED: 4103,

  AUTH_TOKEN_INVALID: 4301,
  CAPTCHA_TOKEN_VALIDATION_FAIL: 4306,
  CAPTCHA_TOKEN_VALIDATION_REQUEST_FAIL: 4307,
  LOGIN_ALREADY_EXIST: 4308,

  NOT_FOUND: 4400,
  INTERNAL_ERROR: 5000,

  VERIFICATION_REQUIRED: 4501,
  VERIFICATION_NOT_SUPPORTED: 4502,
  VERIFICATION_NOT_CONFIGURED: 4503,
  VERIFICATION_INVALID_CODE: 4504,
  VERIFICATION_NOT_IMPLEMENTED: 4505,

  RATE_LIMIT: 4029,
  UNKNOWN_ERROR: 6001
}
